import React from "react";
import { motion } from "framer-motion";

export default function BlogDetailsPage() {
  // Dummy blogs (replace with your real data or props)
  const blogs = [
    {
      img: "https://framerusercontent.com/images/0axqyVCCRVuCTMDBb1xJ1V1iYQ.png",
      title: "The Future of Digital Agencies",
      desc: "How agencies are reshaping the online landscape.",
      time: "August 25, 2025 • 5 min read",
      personIMG:
        "https://framerusercontent.com/images/v0xx4IJ0QzD07LzPBOUBMr9mzI.png",
    },
    {
      img: "https://framerusercontent.com/images/Pz4mZM58FRoqLNfMDZ7ct0bw.png",
      title: "Why SEO Still Matters",
      desc: "Discover why SEO is a long-term investment for growth.",
      time: "August 21, 2025 • 8 min read",
      personIMG:
        "https://framerusercontent.com/images/v0xx4IJ0QzD07LzPBOUBMr9mzI.png",
    },
    {
      img: "https://framerusercontent.com/images/Ip3c5dPuOiBW3bfi0UR2kpTtk.png",
      title: "Content Marketing Trends",
      desc: "Top strategies to boost engagement in 2025.",
      time: "August 18, 2025 • 6 min read",
      personIMG:
        "https://framerusercontent.com/images/v0xx4IJ0QzD07LzPBOUBMr9mzI.png",
    },
  ];

  // Animation variants
  const headingVariant = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  return (
    <div className="max-w-4xl mx-auto px-6 py-12">
      {/* Title */}
      <motion.h1
        className="text-4xl font-bold text-gray-900 mb-6"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        How Digital Agencies Transform Online Presence
      </motion.h1>

      {/* Author + Meta */}
      <div className="flex items-center space-x-4 mb-8">
        <img
          src="https://framerusercontent.com/images/v0xx4IJ0QzD07LzPBOUBMr9mzI.png?scale-down-to=512"
          alt="Author"
          className="w-12 h-12 rounded-full"
        />
        <div>
          <p className="text-gray-800 font-medium">John Doe</p>
          <p className="text-gray-500 text-sm">August 20, 2025 • 10 min read</p>
        </div>
      </div>

      {/* Cover Image */}
      <motion.img
        src="https://framerusercontent.com/images/0axqyVCCRVuCTMDBb1xJ1V1iYQ.png?scale-down-to=1024"
        alt="Blog Cover"
        className="w-full h-[400px] object-cover rounded-2xl shadow-lg mb-8"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2 }}
      />

      {/* Blog Content */}
      <div className="prose max-w-none text-gray-700 leading-relaxed">
        {/* Section 1 */}
        <motion.h2
          className="text-2xl font-bold text-gray-900 mb-3"
          variants={headingVariant}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          Brand Discovery & Strategy
        </motion.h2>
        <p>
          Digital agencies begin by understanding your business, audience, and
          goals. Through workshops, research, and audits, they identify what
          makes your brand unique and how to position it online.
        </p>

        {/* Section 2 */}
        <motion.h2
          className="text-2xl font-bold text-gray-900 mt-8 mb-3"
          variants={headingVariant}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          Website Design & Development
        </motion.h2>
        <p>
          Your website is your digital storefront. A digital agency ensures it’s
          not only visually appealing but also functional, fast, and optimized
          for conversions.
        </p>

        <ul className="list-disc pl-6 mt-3 space-y-2">
          <li>UI/UX design that keeps users engaged</li>
          <li>Mobile responsiveness and accessibility</li>
          <li>SEO-optimized and scalable code</li>
          <li>Seamless user journeys that drive results</li>
        </ul>

        {/* Section 3 */}
        <motion.h2
          className="text-2xl font-bold text-gray-900 mt-8 mb-3"
          variants={headingVariant}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          Search Engine Optimization (SEO)
        </motion.h2>
        <p>
          Visibility is key. Digital agencies optimize your content and
          structure to make sure your website ranks high on Google and other
          search engines.
        </p>

        <p className="font-semibold mt-3">This includes:</p>
        <ul className="list-disc pl-6 mt-2 space-y-2">
          <li>Keyword research and on-page SEO</li>
          <li>Technical SEO audits and improvements</li>
          <li>Link building and content optimization</li>
          <li>Local SEO for area-specific visibility</li>
        </ul>

        {/* Section 4 */}
        <motion.h2
          className="text-2xl font-bold text-gray-900 mt-8 mb-3"
          variants={headingVariant}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          Content Creation & Marketing
        </motion.h2>
        <p>
          High-quality content builds trust and attracts the right audience.
          Agencies create and manage content that resonates—whether it’s blog
          posts, videos, social media content, or newsletters.
        </p>

        <p className="font-semibold mt-3">Benefits:</p>
        <ul className="list-disc pl-6 mt-2 space-y-2">
          <li>Consistent brand messaging</li>
          <li>Improved search engine ranking</li>
          <li>Greater user engagement and conversion</li>
        </ul>

        {/* Two images */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          <motion.img
            src="https://framerusercontent.com/images/Pz4mZM58FRoqLNfMDZ7ct0bw.png?scale-down-to=1024"
            alt="Digital Agency Work 1"
            className="rounded-2xl shadow-md w-full h-auto"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          />
          <motion.img
            src="https://framerusercontent.com/images/Ip3c5dPuOiBW3bfi0UR2kpTtk.png?scale-down-to=1024"
            alt="Digital Agency Work 2"
            className="rounded-2xl shadow-md w-full h-auto"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          />
        </div>

        {/* Final Thoughts */}
        <motion.h2
          className="text-2xl font-bold text-gray-900 mt-8 mb-3"
          variants={headingVariant}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          Final Thoughts
        </motion.h2>
        <p>
          A digital agency doesn’t just build websites or run ads—they act as a
          long-term digital partner focused on growing your brand online. With
          the right team, you can go from having a basic online presence to
          becoming a trusted, recognizable digital force.
        </p>

        {/* Share Section */}
        <div className="mt-10">
          <p className="text-lg font-semibold text-gray-800 mb-4">
            Share this post
          </p>
          <div className="flex space-x-6">
            <a
              href="https://www.facebook.com/sharer/sharer.php?u=https://your-blog-url.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 text-2xl"
            >
              <i className="fab fa-facebook"></i>
            </a>
            <a
              href="https://twitter.com/intent/tweet?url=https://your-blog-url.com&text=Check%20out%20this%20post!"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sky-500 hover:text-sky-700 text-2xl"
            >
              <i className="fab fa-twitter"></i>
            </a>
            <a
              href="https://www.linkedin.com/shareArticle?mini=true&url=https://your-blog-url.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-700 hover:text-blue-900 text-2xl"
            >
              <i className="fab fa-linkedin"></i>
            </a>
          </div>
        </div>

        {/* Related Blogs Section */}
        <div className="mt-16">
          <p className="text-sm font-semibold text-blue-600 flex items-center">
            <span className="w-2 h-2 bg-blue-600 rounded-full mr-2"></span>
            Latest News & Blogs
          </p>
          <motion.h2
            className="text-5xl font-bold text-gray-900 mt-2 mb-8"
            variants={headingVariant}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            Related Blog Post
          </motion.h2>

          {/* Blogs Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogs.map((blog, i) => (
              <div key={i} className="group relative">
                {/* Image container */}
                <div className="relative overflow-hidden rounded-xl">
                  <img
                    src={blog.img}
                    alt={blog.title}
                    className="rounded-xl w-full h-48 sm:h-56 lg:h-64 object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  {/* Person avatar */}
                  <div className="absolute bottom-4 left-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <img
                      src={blog.personIMG}
                      alt="Author"
                      className="w-14 h-14 rounded-xl border-2 border-white shadow-xl"
                    />
                  </div>
                </div>

                {/* Blog details */}
                <p className="text-black text-sm font-light sm:text-base mt-4">
                  {blog.time}
                </p>
                <h3 className="text-lg sm:text-xl lg:text-2xl font-semibold mt-2">
                  {blog.title}
                </h3>
                <p className="text-[#4a4f54] text-sm sm:text-base mt-1">
                  {blog.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
